<template>
  <Card>
    <div class="flex j_b">
      <h4>发票信息</h4>
      <div>
        <Button type="primary" class="public-fr" icon="ios-undo" @click="back"
          >返回</Button
        >
        <Button
          v-if="detail.invoiceStatus == 0"
          type="primary"
          class="public-fr"
          @click="approve"
          >审核</Button
        >
      </div>
    </div>
    <table style="margin-top: 40px">
      <tr>
        <th colspan="7">零售商发票信息</th>
      </tr>
      <tr>
        <th>资金商</th>
        <td>{{ detail.dealerName }}</td>
        <th>渠道</th>
        <td>{{ detail.channelCode }}</td>
        <th>发票营业执照</th>
        <td>
          <Avatar
            shape="square"
            size="large"
            :src="detail.invoiceImgLecienceUrl"
            class="img_icon"
          />
        </td>
      </tr>
      <tr>
        <th>门店等级</th>
        <td>{{ detail.grade }}</td>
        <th>零售商名称</th>
        <td>{{ detail.retName }}</td>
        <th>门店ID</th>
        <td>{{ detail.retCode }}</td>
      </tr>
      <tr>
        <th>是否开发票</th>
        <td>{{ detail.invoiceIsOpen == 0 ? "否" : "是" }}</td>
        <th>发票类型</th>
        <!-- ：1-增值税专用发票  2-增值税普通发票 -->
        <td>
          {{ detail.invoiceType == 1 ? "增值税专用发票" : "增值税普通发票" }}
        </td>
        <th>开票是否主体本身</th>
        <td>{{ detail.invoiceIsSelf == 0 ? "否" : "是" }}</td>
      </tr>
      <tr>
        <th>公司名称</th>
        <td>{{ detail.invoiceCompany }}</td>
        <th>税号</th>
        <td>{{ detail.invoiceLecienceCode }}</td>
        <th>单位地址</th>
        <td>{{ detail.companyAddress }}</td>
      </tr>
      <tr>
        <th>联系电话</th>
        <td>{{ detail.invoiceMobile }}</td>
        <th>开户银行</th>
        <td>{{ detail.bankName }}</td>
        <th>银行账号</th>
        <td>{{ detail.bankName }}</td>
      </tr>
      <tr>
        <th>收件人姓名</th>
        <td>{{ detail.invoiceReceiveName }}</td>
        <th>收件人电话</th>
        <td>{{ detail.invoiceReceiveName }}</td>
        <th>收件人地址</th>
        <td>{{ detail.invoiceReceiveAddr }}</td>
      </tr>
      <tr>
        <th>审核时间</th>
        <td>{{ detail.invoiceAuditTime }}</td>
        <th>审核状态</th>
        <!-- ,0待审核、1审核通过、2审核驳回、/ -->
        <td>
          {{
            detail.invoiceStatus == 0
              ? "待审核"
              : detail.invoiceStatus == 1
              ? "审核通过"
              : "审核驳回"
          }}
        </td>
        <th>专票授权文件</th>
        <td>
          <Avatar
            shape="square"
            size="large"
            :src="detail.specialInvoiceAuthDocUrl"
            class="img_icon"
          />
        </td>
      </tr>
    </table>

    <Modal v-model="ModalVisible" title="发票审核" :footer-hide="true">
      <Form
        :label-width="100"
        ref="formValidate"
        :model="formInline"
        :rules="ruleValidate"
      >
        <FormItem label="审核结果：" prop="invoiceStatus">
          <Select
            v-model="formInline.invoiceStatus"
            placeholder="请选择审核结果"
          >
            <!-- 1审核通过、2审核驳回、/ -->
            <Option value="1">审核通过</Option>
            <Option value="2">审核驳回</Option>
          </Select>
        </FormItem>
        <FormItem
          label="备注："
          prop="invoiceRemark"
          :rules="
            formInline.invoiceStatus == '2'
              ? ruleValidate.invoiceRemark
              : [{ required: false }]
          "
        >
          <Input v-model="formInline.invoiceRemark" type="textarea"></Input>
        </FormItem>
        <div style="text-align: right; padding: 20px 0">
          <Button size="large" type="default" @click="cancelAction"
            >取消</Button
          >
          <Button size="large" type="primary" @click="addAction">确认</Button>
        </div>
      </Form>
    </Modal>
  </Card>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      ModalVisible: false,
      formInline: {
        invoiceRemark: "",
        invoiceStatus: "",
      },
      ruleValidate: {
        invoiceStatus: [
          { required: true, message: "审核结果不能为空", trigger: "change" },
        ],
        invoiceRemark: [
          { required: true, message: "请填写不通过原因", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.detail = JSON.parse(this.$route.query.detail);
  },
  methods: {
    back() {
      this.$router.push({
        path: "invoiceList",
      });
    },
    approve() {
      this.ModalVisible = true;
    },
    addAction() {
      let data = { ...this.formInline };
      data.retCode = this.detail.retCode;
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$api.invoiceApprove(data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.detail.invoiceStatus = data.invoiceStatus;
            }
          });
        }
      });
    },
    cancelAction() {
      Object.keys(this.formInline).forEach((key) => {
        this.formInline[key] = "";
      });
      this.$refs["formValidate"].resetFields();
      this.ModalVisible = false;
    },
  },
};
</script>
<style scoped>
table {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
}

th,
td {
  padding: 0 10px;
  text-align: center;
  border: 1px solid #dcdee2;
  line-height: 30px;
  color: #515a6e;
  font-size: 12px;
}

th {
  background: #f8f8f9;
}

.flex {
  display: flex;
  align-items: center;
}

.j_b {
  justify-content: space-between;
}

.img_icon {
  margin: 10px;
}
</style>





// WEBPACK FOOTER //
// src/views/store/invoiceDetail.vue